import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PRODUCT } from '../../constants/queryKeys';
import ProductApiV2 from '../../lib/api/product/ProductApiV2';
import { QueryOptions } from '../../types/query/useQuery';
import { ProductResponseDto } from '../../types/api/products';

type UseFetchProductListQuery<SelectResultType> = {
  productId?: number;
  options?: QueryOptions<ProductResponseDto, unknown, SelectResultType>;
};

export const useFetchProductQuery = <SelectResultType>({
  productId,
  options,
}: UseFetchProductListQuery<SelectResultType>): UseQueryResult<SelectResultType, unknown> => {
  return useQuery<ProductResponseDto, unknown, SelectResultType>(
    [...PRODUCT.LIST, productId],
    () => ProductApiV2.fetchProductInfo(productId as number),
    {
      ...options,
      enabled: !!productId,
      suspense: true,
    },
  );
};
